import api from "./axios";

export function getNativePosDiscountCapability(options = {}) {
  return api.get("/pos/discount-capability", { signal: options.signal });
}

export function lookupNativePosBarcode(code, options = {}) {
  return api.get("/pos/barcodes/lookup", {
    params: { code, pricing_mode: options.pricingMode || "RETAIL" },
    signal: options.signal,
  });
}

export function searchNativePosProducts(query, limit = 24, options = {}) {
  return api.get("/pos/products/search", {
    params: { query, limit, pricing_mode: options.pricingMode || "RETAIL" },
    signal: options.signal,
  });
}

export function finalizeNativePosSale(payload, idempotencyKey, options = {}) {
  const headers = { "Idempotency-Key": idempotencyKey };
  if (options.storeBridgeDeviceId) {
    headers["X-Store-Bridge-Device-Id"] = options.storeBridgeDeviceId;
  }
  return api.post("/pos/sales/finalize", payload, { headers });
}

export function getNativePosSale(salePublicId, options = {}) {
  return api.get(`/pos/sales/${encodeURIComponent(salePublicId)}`, {
    signal: options.signal,
  });
}


export function returnNativePosSaleItem(salePublicId, payload, idempotencyKey) {
  return api.post(
    `/pos/sales/${encodeURIComponent(salePublicId)}/returns`,
    payload,
    { headers: { "Idempotency-Key": idempotencyKey } },
  );
}
